import React from 'react'
import { Link } from 'react-scroll'



const Pricing = (props) => {
    const ClickHandler = () => {
        document.querySelector('#contact-message').value="I have a work for you! Let's discuss details. Contacct me."
        document.querySelector('#contact-email').focus()
    }

    const pricing = [
        {
            rate: '$50/hr',
            des: 'Essential full stack services for startups and small projects.',
            li1: 'Custom website or web app development.',
            li2: 'Mobile and desktop responsive update.',
            li3: 'Basic backend and database setup.',
            li4: 'Post-launch support and minor updates.',
            title: 'Basic',
            link: '/',
        },
        {
            rate: 'same $50/hr',
            des: 'Scalable, high-performance solutions for growing businesses.',
            li1: 'Advanced frontend/backend development.',
            li2: 'Third-party API integrations.',
            li3: 'Performance and security optimization.',
            li4: 'Regular maintenance and upgrades.',
            title: 'Premium',
            link: '/',
        },
        {
            rate: '$50/hr yet',
            des: 'The top-tier experience (still $50/hr, because why not?).',
            li1: 'Basic and Premium, plus extra sparkles.',
            li2: 'Code so clean, it shines.',
            li3: 'A developer who laughs at your jokes.',
            li4: 'No surprises—just $50/hr, always.',
            title: 'Advanced',
            link: '/',
        },


    ]


    return (
        <section className="tp-pricing-section section-padding">
            <div className="container">
                <div className="tp-section-title">
                    <span>Pricing</span>
                    <h2>My Pricing Plan</h2>
                </div>
                <div className="tp-pricing-wrap">
                    <div className="row">
                        {pricing.map((pricing, ptem) => (
                            <div className="col col-lg-4 col-md-6 col-12" key={ptem}>
                                <div className="tp-pricing-item">
                                    <div className="tp-pricing-top">
                                        <div className="pricing-thumb">
                                            <span>{pricing.title}</span>
                                        </div>
                                        <div className="tp-pricing-text">
                                            <h2>{pricing.rate}<span></span></h2>
                                            <p>{pricing.des}</p>
                                        </div>
                                    </div>
                                    <div className="tp-pricing-bottom">
                                        <div className="tp-pricing-bottom-text">
                                            <ul>
                                                <li>{pricing.li1}</li>
                                                <li>{pricing.li2}</li>
                                                <li>{pricing.li3}</li>
                                                <li>{pricing.li4}</li>
                                            </ul>
                                            <div className='pricing-btn'>
                                                <Link onClick={ClickHandler} to="contact" spy={true} smooth={true} duration={500} offset={-95}>Choose Plan</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="visible-rotate-text">
                <h1>My Pricing</h1>
            </div>
        </section>
    )
}

export default Pricing;